import React, { useState } from "react";
import Checkbox from "canvas-core-react/lib/Checkbox";

interface CheckboxComponentProps {
  id: string;
  text: string;
}

export const CheckboxComponent = ({ id, text }: CheckboxComponentProps) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleOnChange = () => setIsChecked(!isChecked);

  return (
    <Checkbox
      checked={isChecked}
      id={id}
      label={text}
      onChange={handleOnChange}
    />
  );
};
